module.exports = __webpack_public_path__ + "img/SchedulePickup.7ba4d274.svg";